/* eslint-disable */
class NavWrapper {
	container
	list = []
	setContainer (container) {
		this.container = container
		const list = this.container.querySelectorAll('[data-product]');
		[...list].forEach(item => {
			this._createNav(item)
		})
		return this
	}
	
	_createNav(element){
		let id = element.dataset.product
		this.list[id] = element 
	}
}

const navWrapper = new NavWrapper()
export {
	NavWrapper,
	navWrapper
}
